<div class="container-fluid text-center">
  <h3>Confirm Booking</h3>
  <!-- <error-message [message]="errorMessage"></error-message> -->

  <div>
    @if (siteVisit) {
      <div class="title">
        {{ siteVisit.title }}
      </div>
      <div class="">{{ siteVisit.county }} @if (siteVisit.county && siteVisit.state) {
        <span>,</span>
      } {{ siteVisit.state }}</div>
      <div>
        {{ siteVisit.startDateTime | date: "short" }}
        <div class="date-sep">
          <i class="fa fa-chevron-right"></i>
        </div>
        {{ siteVisit.endDateTime | date: "short" }}
      </div>
    }
  </div>

  <div class="btn-continue">
    <button
      type="button"
      class="btn btn-primary btn-lg btn-lg-round btn-block "
      [disabled]="loading || !confirmEnabled"
      (click)="confirmBooking()"
      >
      @if (loading) {
        <i class="fa fa-circle-notch fa-spin"></i>
      }
      Confirm
    </button>
  </div>
</div>
